import * as React from "react";
import { Area } from "../models/Area";
import { ProtectiveFunction } from "../models/ProtectiveFunction";
import * as moment from "moment";
import { formatDate } from "../helpers";

interface Props {
  protectiveFunction: ProtectiveFunction;
  area: Area;
  userName: string;
}

export class ProjectInfoHeader extends React.Component<Props, {}> {
  constructor(props: Props) {
    super(props);
  }

  render() {
    const labelStyle: React.CSSProperties = {
      color: "blue",
      fontSize: "medium",
      fontWeight: "bold"
    };

    return (
      <div
        style={{
          borderTop: "1px solid black",
          borderLeft: "1px solid black",
          borderRight: "1px solid black",
          height: "50px",
          width: "100%"
        }}
      >
        <table className="silsolver_meddile_page" style={{ width: "100%" }}>
          <tbody>
            <tr style={{ width: "100%" }}>
              <td
                className="sil_head_leftside"
                style={{
                  width: "70%",
                  padding: "0px 0px",
                  display: "table-cell"
                }}
              >
                <table className="sub_title">
                  <tbody>
                    <tr>
                      <td style={{ paddingLeft: "20px" }}>Client:</td>
                      <td style={{ paddingLeft: "12px" }}>
                        <span style={labelStyle}>
                          {this.props.area.clientId}
                        </span>
                      </td>
                      <td style={{ paddingLeft: "40px" }}>Function:</td>
                      <td style={{ paddingLeft: "10px" }}>
                        <span style={labelStyle}>
                          {this.props.protectiveFunction.softKeyDescription}
                        </span>
                      </td>
                      <td style={{ paddingLeft: "40px" }}>
                        Modified:
                      </td>
                      <td>                         
                        {this.props.protectiveFunction.updatedDate ? formatDate(this.props.protectiveFunction.updatedDate) + ' ': ''}
                        by {this.props.protectiveFunction.updatedByUserName}
                      </td>
                    </tr>
                    <tr>
                      <td style={{ paddingLeft: "20px" }}>Project ID:</td>
                      <td style={{ paddingLeft: "10px" }}>
                        <span style={labelStyle}>
                          {this.props.protectiveFunction.projectKey}
                        </span>
                      </td>
                      <td style={{ paddingLeft: "40px" }}>Function ID:</td>
                      <td style={{ paddingLeft: "10px" }}>
                        <span style={labelStyle}>
                          {this.props.protectiveFunction.softKey}
                        </span>
                      </td>
                      <td style={{ paddingLeft: "40px" }}>
                        <span style={labelStyle}>
                          {this.props.protectiveFunction.isLocked ? 'READ ONLY' : ''}  
                        </span>
                        
                      </td>
                      <td>                        

                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>

              <td
                style={{
                  width: "10%",
                  display: "table-cell",
                  textAlign: "right"
                }}
              >
                <div id="userlogin">
                  <span style={{ fontSize: "small" }}>Welcome, </span>
                  <span style={{ fontSize: "small", fontWeight: "bold" }}>
                    {this.props.userName}
                  </span>
                </div>
              </td>
              <td>
                <a href="/SIL Solver Enterprise User Instructions V1-3-0.pdf" target="_blank" className="btn" style={{
                  background: "#62A669",
                  color: "white",
                  marginLeft: "10px"
                }}>
                  User Guide
                </a>
              </td>
              <td style={{ width: "20%", display: "table-cell" }}>
                <div
                  className="logo_img"
                  style={{ height: "50px", textAlign: "center" }}
                >
                  <img
                    src="/Images/logo.png"
                    alt=""
                    title=""
                    style={{ width: "62%" }}
                  />
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    );
  }
}
